module.exports = __webpack_public_path__ + "static/media/Rectangle 1219.feb36d3f.jpeg";